const icons = {
    creation: <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-brand-telegram" width="20"
                   height="20" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" fill="none"
                   strokeLinecap="round"
                   strokeLinejoin="round">
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M15 10l-4 4l6 6l4 -16l-18 7l4 2l2 6l3 -4"/>
    </svg>,
    list: <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-checklist" width="20"
               height="20" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round"
               strokeLinejoin="round">
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M9.615 20h-2.615a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8"></path>
        <path d="M14 19l2 2l4 -4"></path>
        <path d="M9 8h4"></path>
        <path d="M9 12h2"></path>
    </svg>,
}

// ==============================|| UTILITIES MENU ITEMS ||============================== //

const campaigns = {
    id: 'campaigns',
    title: 'Campaigns',
    type: 'group',
    role: [1, 2, 3],
    children: [
        {
            id: '/campaign/creation',
            title: 'Creation',
            type: 'item',
            url: '/campaign/creation',
            icon: icons.creation,
            role: [1, 2, 3],
            breadcrumbs: false
        },
        {
            id: '/campaign/list',
            title: 'Campaign List',
            type: 'item',
            url: '/campaign/list',
            icon: icons.list,
            role: [1, 2, 3],
            breadcrumbs: false
        },
    ]
};

export default campaigns;
